// Personal details constants for use throughout the portfolio

const MyDetails = {
  name: "ACT91",
  fullName: "Stanley Gersom", // Replace with your full name if different
  email: "stanleygersom@gmail.com", // Replace with your actual email
  nickname: "ACT91",
  github: {
    profile: "https://github.com/ACT91",
    repositories: "https://github.com/ACT91?tab=repositories"
  },
  socialMedia: {
    linkedin: "https://www.linkedin.com/in/stanley-gersom/", // Replace with your actual LinkedIn
   // twitter: "https://twitter.com/yourhandle", // Replace with your actual Twitter
  },
  about: {
    title: "Software Developer",
    shortBio: "Passionate software developer focused on creating innovative solutions."
  }
};

export default MyDetails;